import { render, staticRenderFns } from "./_BroadcastTypePropertiesPanel.vue?vue&type=template&id=6d7dde74&scoped=true&"
import script from "./_BroadcastTypePropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./_BroadcastTypePropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastTypePropertiesPanel.vue?vue&type=style&index=0&id=6d7dde74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7dde74",
  null
  
)

export default component.exports